export default {"src":"/_next/static/media/hexagon_border.5a167480.svg","height":538,"width":569};